// Copyright (c) 2019 Deere & Company

import { resetPinPlateData } from './reset-pin-plate-data';
import { searchPinPlateData } from './search-pin-plate-data';

export default {
    searchPinPlateData,
    resetPinPlateData,
};
